/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCaseAlertData } from './InternalApiCaseAlertData';
import {
    InternalApiCaseAlertDataFromJSON,
    InternalApiCaseAlertDataFromJSONTyped,
    InternalApiCaseAlertDataToJSON,
    InternalApiCaseAlertDataToJSONTyped,
} from './InternalApiCaseAlertData';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiCaseAlert
 */
export interface InternalApiCaseAlert {
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiCaseAlert
     */
    createdBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCaseAlert
     */
    createdAt: Date;
    /**
     * 
     * @type {InternalApiCaseAlertData}
     * @memberof InternalApiCaseAlert
     */
    alert: InternalApiCaseAlertData;
}

/**
 * Check if a given object implements the InternalApiCaseAlert interface.
 */
export function instanceOfInternalApiCaseAlert(value: object): value is InternalApiCaseAlert {
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('alert' in value) || value['alert'] === undefined) return false;
    return true;
}

export function InternalApiCaseAlertFromJSON(json: any): InternalApiCaseAlert {
    return InternalApiCaseAlertFromJSONTyped(json, false);
}

export function InternalApiCaseAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'createdAt': (new Date(json['createdAt'])),
        'alert': InternalApiCaseAlertDataFromJSON(json['alert']),
    };
}

export function InternalApiCaseAlertToJSON(json: any): InternalApiCaseAlert {
    return InternalApiCaseAlertToJSONTyped(json, false);
}

export function InternalApiCaseAlertToJSONTyped(value?: InternalApiCaseAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'createdAt': value['createdAt'].toISOString(),
        'alert': InternalApiCaseAlertDataToJSON(value['alert']),
    };
}

